module.exports = __webpack_public_path__ + "static/media/logo_strong.0a582a2d.svg";